import { request } from '@/utils/request'

// 状态
const SHOW_TREE = 'SHOW_TREE' // 是否需要树           == commit 常量
const TREE_FILTER_TEXT = 'TREE_FILTER_TEXT' // 树形结构的检索    == commit 常量

// data
const TREE_DATA = 'TREE_DATA' // 树形数据                == commit 常量
const SELECT_TREE_NODE = 'SELECT_TREE_NODE' // 当前选择的树形节点       == commit 常量

const CommonService = {
  // namespaced: true,
  state: {
    showTree: false, // 是否需要展示tree
    tree_filterText: '', // 检索字段
    treeDta: [], // 整tree数据
    selectTreeNode: {}, // 当前所选择的树节点 // 默认是treeData首项 // 单纯节点 // 不区分类型
    group_tree: [], // 分组架构tree数据
    yici_tree: [], // 一次架构tree数据
    menuList: []
  },

  mutations: {
    [TREE_DATA](state, data) {
      state.treeDta = data
    },
    [SHOW_TREE](state = CommonService.state, data) {
      state.showTree = data
    },
    [TREE_FILTER_TEXT](state = CommonService.state, data) {
      state.tree_filterText = data
    },
    [SELECT_TREE_NODE](state = CommonService.state, data) {
      state.selectTreeNode = data
    },
    SET_MENU_LIST(state = CommonService.state, data) {
      state.menuList = data
    }
  },

  actions: {
    // 获取公共树（带GUID，可根据用能模型统计数据）// 存全局
    GetCommomTree({ commit, rootState }, params) {
      // 分组树
      request.get('/api/chengwu/v2/GetCommomTree',
        {
          GroupFilter: 3,
          EquipmentGroupClassRange: 0,
          IncludeUngroupedItem: 0,
          ProjectIDstr: rootState.projects.selectProject.IdStr,
          ListCalculateType: 1
        }).then(response => {
        commit(TREE_DATA, response.Data_Obj)
        if (!rootState['business/CommonService'].selectTreeNode) {
          commit(SELECT_TREE_NODE, response.Data_Obj.Tree[0])
        }
        rootState['business/CommonService'].group_tree = response.Data_Obj
      })
      // 一次结构树
      request.get('/api/chengwu/v2/GetCommomTree',
        {
          GroupFilter: 3,
          EquipmentGroupClassRange: 1,
          IncludeUngroupedItem: 0,
          ProjectIDstr: rootState.projects.selectProject.IdStr,
          ListCalculateType: 1
        }).then(response => {
        rootState['business/CommonService'].yici_tree = response.Data_Obj
      })
      // 环境树
      request.get('/api/chengwu/v2/GetCommomTree',
        {
          GroupFilter: 3,
          EquipmentGroupClassRange: 0,
          IncludeUngroupedItem: 0,
          ProjectIDstr: rootState.projects.selectProject.IdStr,
          ListCalculateType: 3
        }).then(response => {
        rootState['business/CommonService'].hj_tree = response.Data_Obj
      })
    },
    // 切换分组树、一次结构树
    switchTree({ commit, rootState }, data) {
      if (data === 0) {
        commit(TREE_DATA, rootState['business/CommonService'].group_tree)
        commit(SELECT_TREE_NODE, rootState['business/CommonService'].group_tree.Tree[0])
      } else if (data === 1) {
        commit(TREE_DATA, rootState['business/CommonService'].yici_tree)
        commit(SELECT_TREE_NODE, rootState['business/CommonService'].yici_tree.Tree[0])
      } else {
        commit(TREE_DATA, rootState['business/CommonService'].hj_tree)
        commit(SELECT_TREE_NODE, rootState['business/CommonService'].hj_tree.Tree[0])
      }
    },
    // 存当前节点
    SetSelectTreeNode({ commit }, data) {
      commit(SELECT_TREE_NODE, data)
    },

    // 获取项目树
    GetProjectTree({ commit }) {
      return new Promise((resolve, reject) => {
        request.get('/api/chengwu/v2/GetProjectTree').then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取设备属性信息
    GetPropertysByEquipmentID({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/GetPropertysByEquipmentID', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 通过通用结构获取能流图
    GetSankeyByStructureCommon({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/chengwu/v2/GetSankeyByStructureCommon', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取菜单权限
    GetClientsDataJson_Vue3({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/ClientsData/GetClientsDataJson_Vue3').then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default CommonService
